// UI dimensions
export const SHEET_WIDTH_PX = 600
export const SHEET_WIDTH = `${SHEET_WIDTH_PX}px`

// One-line summary of what upgrading to Pro unlocks. Shared by the /account and
// /billing plan cards so the two never drift (they previously listed different
// benefits). Keep this the complete list of Pro perks.
export const PRO_UPGRADE_TAGLINE = `Upgrade to unlock AI analysis, PDF exports, and calendar exports.`
